module.exports = __webpack_public_path__ + "static/media/portoex.58b2a5fb.png";